import { MemberStatus } from '@libs/shared';

/**
 * 是否为离职成员或互联组织被移除的对接人
 *
 * @param status MemberStatus
 */
export const isResignedMember = (status?: MemberStatus | number) => {
    return status === MemberStatus.dismission;
};
